import React, { Component, type KeyboardEvent } from 'react';
import { styled } from '@compiled/react';
import noop from 'lodash/noop';
import Button from '@atlaskit/button';
import { components } from '@atlaskit/select';
import Spinner from '@atlaskit/spinner';
import { token } from '@atlaskit/tokens';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import type { ItemGroup, OnShowMoreClick } from '../../../model/index.tsx';
import { stopImmediatePropagation } from '../../../services/stop-immediate-propagation/index.tsx';

type Props = {
	data: ItemGroup;
	onShowMore: OnShowMoreClick;
};

// eslint-disable-next-line jira/react/no-class-components
export default class Group extends Component<Props> {
	static defaultProps = {
		onShowMore: noop,
	};

	onShowMoreKeyDown = (e: KeyboardEvent) => {
		// menu should be able to close
		// but all other events should not be passed to the react-select
		if (e.key !== 'Escape') {
			e.stopPropagation();
		}
	};

	onShowMoreClick = stopImmediatePropagation(() => this.props.onShowMore());

	renderShowMore() {
		const { showMore } = this.props.data;
		if (!showMore) {
			return null;
		}

		if (showMore.isLoading) {
			return (
				<ShowMoreWrapper>
					<Spinner size="medium" />
				</ShowMoreWrapper>
			);
		}

		return (
			<ShowMoreWrapper
				onKeyDown={this.onShowMoreKeyDown}
				// eslint-disable-next-line jira/integration/test-id-by-folder-structure
				data-test-id="navigation-apps.common.compontents.switcher.switcher.group.show-more"
			>
				{/* eslint-disable-next-line jsx-a11y/role-has-required-aria-props */}
				<Button role="option" onClick={this.onShowMoreClick}>
					{showMore.label}
				</Button>
			</ShowMoreWrapper>
		);
	}

	render() {
		return (
			<>
				{/* @ts-expect-error - TS2740 - Type '{ data: ItemGroup; onShowMore: OnShowMoreClick; children?: ReactNode; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': clearValue, cx, getStyles, getValue, and 8 more. */}
				<components.Group {...this.props} />
				{this.renderShowMore()}
			</>
		);
	}
}

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ShowMoreWrapper = styled.div({
	marginTop: token('space.100'),
	marginRight: token('space.100'),
	marginBottom: token('space.100'),
	marginLeft: token('space.100'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${4 * gridSize}px`,
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
});
